import { BaseElementDefBase, BaseElementDef, ICustomViewElement } from "./BaseElementDef";
import { FileDocumentSettings } from "@cs-ts/file-document-settings";
import { CalculationContext } from "./__CalculationContextInterface";
import { FormItem } from "@cs/FormItem";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { TrueFalseCalculated } from "@cs-ts/true-false-calculated";
import { isFileDef } from "./FileDef";

const TYPE_NAME = "MI.Common.DynamicForms.Models.DFFileDocument"; // TODO - not hardcoded?
export default class FileDocumentDef extends BaseElementDef<FileDocumentSettings, FormDefinitionItem<FileDocumentSettings>, FormItem> implements ICustomViewElement {
    isCustomViewType: true;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<FileDocumentSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = TYPE_NAME; // TODO - not hardcoded?
        this.isCustomViewType = true;
    }

    visible() {
        const showByDefault = this.definition.settings.showByDefault;
        if (this.getRoot().getElementsByFilter((x: BaseElementDefBase) => x.id == this.definition.settings.fileUploadId && isFileDef(x) && x.isFileUpload && parseInt(x.fileSize) > 0).length == 0) {
            return Promise.resolve(false);
        }
        if (showByDefault == TrueFalseCalculated.True) {
            return Promise.resolve(true);
        } else if (showByDefault == TrueFalseCalculated.False) {
            return Promise.resolve(false);
        } else {
            return this.resolveCalculationPromiseBool(this.definition.settings.showByDefaultCalculatedId!);
        }
    }

    viewTypes() {
        return [this.definition.settings.label!];
    }
}

export function isFileDocumentDef(i: BaseElementDefBase): i is FileDocumentDef {
    return i.typeName == TYPE_NAME;
}
